





























import { Component } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import { AxiosPromise } from 'axios';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import moment from 'moment';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import Mapa from '@/pantallas/Inicio/Mapa/MapaRepetirDiaV2.vue';
import {
  MsResponseData,
  fetchUbicacion,
} from '@/pantallas/VerUbicacion/fetchData';
import { toInteger } from 'lodash';

@Component({
  components: {
    mapa: Mapa,
  },
})
export default class TarifasPantalla extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.ReportesPeajes;
  loadingService = new LoadingService();

  accionesTotales: PermisoAccion[] = [];
  requestsStart: number = 0;
  isFormValid: boolean = false;
  detalleSeleccionado: any = null;
  patente: string = '';
  mapsActivities: any = [];
  mapHtml: any = '';
  axios = new AxiosVue(ServicioProxy.Metabase);
  infoWindows: google.maps.InfoWindow;
  map: google.maps.Map = null;
  marker: google.maps.Marker = null;
  mapName: any = 'VERUBI';
  MsResponseData: MsResponseData = null;
  interval: any = null;

  mounted() {
    // this.cargarMapa();

    this.initializeRenderMap();
    // this.buscarVehiculo()
    this.interval = setInterval(this.buscarVehiculo, 30000);
  }

  async initializeRenderMap() {
    var lat = -33.45694;
    var lon: number = -70.64827;

    var myLatlng = new google.maps.LatLng(lat, lon);

    var mapOptions: any = {
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      center: myLatlng,
      mapTypeControl: false,
      streetViewControl: true,
      gestureHandling: 'greedy',
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      minZoom: 2,
      maxZoom: 20,
    };
    this.infoWindows = new google.maps.InfoWindow({
      content: '',
    });

    this.map = new google.maps.Map(
      document.getElementById(this.mapName),
      mapOptions
    );
  }

  beforeDestroy() {
    // Clear the interval when the component is about to be destroyed
    clearInterval(this.interval);
  }

  async ultimaUbicacion(id: any) {
    this.MsResponseData = (await this.fetchUbicacion(id)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        this.detalleSeleccionado = this.MsResponseData.data;
        // console.log(this.detalleSeleccionado)
        this.renderMap(
          this.detalleSeleccionado.latitud,
          this.detalleSeleccionado.longitud,
          this.detalleSeleccionado.heading,
          this.detalleSeleccionado.patente,
          this.detalleSeleccionado.fecha,
          this.detalleSeleccionado.ubicacion,
          this.detalleSeleccionado.velocidad,
          this.detalleSeleccionado.cliente,
          this.detalleSeleccionado.flota
        );
      } else {
        this.$snotify.error('Sin Actividades', {
          timeout: 3000,
        });
      }
    }
  }

  fetchUbicacion(id: any) {
    this.showLoading();
    return fetchUbicacion(id)
      .catch(error => {
        this.$snotify.error('Por Favor Verifique la Patente');
        return;
      })
      .finally(() => this.hideLoading());
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  renderMap(
    lat: any,
    lon: any,
    heading: any,
    patente: any,
    date: any,
    ubicacion: any,
    velocidad: any,
    cliente: any,
    flota: any
  ) {
    var myLatlng = new google.maps.LatLng(lat, lon);

    try {
      this.marker.setMap(null);
    } catch (e) {
      console.log(e);
    }

    this.marker = new google.maps.Marker({
      position: myLatlng,
      map: this.map,
      icon: {
        path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        scale: 4,
        fillColor: '#f00',
        strokeColor: '#f00',
        fillOpacity: 1,
        rotation: toInteger(heading),
      },
    });

    this.infoWindows.setContent(
      this.generateHtml(
        lat,
        lon,
        patente,
        date,
        ubicacion,
        velocidad,
        cliente,
        flota
      )
    );
    this.map.setCenter(myLatlng);

    var self = this;
    google.maps.event.addListener(this.marker, 'click', function() {
      self.infoWindows.open(self.map, self.marker);
      // window.open(`https://maps.google.com/?q=${lat},${lon}`);
    });

    // this.infoWindow.open(this.map, marker);

    const mapContainer = document.getElementById(this.mapName);

    mapContainer.addEventListener('mousemove', this.updateMouseCoordinates, {
      passive: true,
    });
  }

  generateHtml(
    lat: string,
    lon: string,
    patente: string,
    date: string,
    ubicacion: string,
    velocidad: string,
    cliente: string,
    flota: string
  ): string {
    var html: string = '';
    const url: string = `https://maps.google.com/?q=${lat},${lon}`;
    html =
      '<div id="content" style="width: 50vh">' +
      '<div id="siteNotice">' +
      '</div>' +
      '<h3 id="firstHeading" class="firstHeading">Última Actividad</h3>' +
      '<div id="bodyContent">' +
      '<p></p>' +
      `<p><b style="font-weight: 700;">Patente: </b> ${patente}</p>` +
      `<p><b style="font-weight: 700;">Cliente: </b> ${cliente}</p>` +
      `<p><b style="font-weight: 700;">Flota: </b> ${flota}</p>` +
      `<p><b style="font-weight: 700;">Fecha de Última Transmisión: </b> ${date}</p>` +
      `<p><b style="font-weight: 700;">Ubicación: </b> ${ubicacion}</p>` +
      `<p><b style="font-weight: 700;">Velocidad: </b> ${velocidad} Km/H</p>` +
      '</div>' +
      '</div>';

    return html;
  }

  updateMouseCoordinates(event: MouseEvent) {
    const point2LatLng = (point: google.maps.Point) => {
      const { map } = this;
      const topRight = map
        .getProjection()
        .fromLatLngToPoint(map.getBounds().getNorthEast());
      const bottomLeft = map
        .getProjection()
        .fromLatLngToPoint(map.getBounds().getSouthWest());
      const scale = Math.pow(2, map.getZoom());
      const worldPoint = new google.maps.Point(
        point.x / scale + bottomLeft.x,
        point.y / scale + topRight.y
      );
      return map.getProjection().fromPointToLatLng(worldPoint);
    };
  }

  async cargarMapa() {
    let cliente_id = localStorage.clienteDefecto;
    const user_id = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user')).id
      : '';
    this.mapHtml =
      'https://apicert.gpschile.com/ms/ubicacion?vehicule_id=' +
      this.patente +
      '&client=' +
      this.clienteId +
      '&user=' +
      user_id;
  }

  buscarVehiculo() {
    // console.log('refresh')
    let cliente_id = localStorage.clienteDefecto;
    const user_id = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user')).id
      : '';
    if (this.patente == '') {
      this.$snotify.error('Por Favor Ingrese una Patente.');
    } else {
      this.ultimaUbicacion({
        client: cliente_id,
        patente: this.patente,
        user: user_id,
      });
    }
    // this.cargarMapa();
  }
}
